export const SOCIAL = {
  linkedin: 'https://www.linkedin.com/in/parthsharma1011/',
  youtube: 'https://www.youtube.com/@beardandbinary',
  instagram: 'https://www.instagram.com/beardandbinary/',
  calendly: 'https://calendly.com/parthsharma1011/30min',
  email: 'parthsharma1011@gmail.com',
  // WhatsApp number not provided by owner — route WhatsApp CTA to email for now
  whatsapp: 'mailto:parthsharma1011@gmail.com?subject=Training%20Enquiry&body=Hi%20Parth%2C%20I%27d%20like%20to%20discuss%20a%20training.',
};

export const CLIENTS = [
  { name: 'HCL', domain: 'hcltech.com' },
  { name: 'Dell', domain: 'dell.com' },
  { name: 'Accenture', domain: 'accenture.com' },
  { name: 'Cognizant', domain: 'cognizant.com' },
  { name: 'Wipro', domain: 'wipro.com' },
  { name: 'DXC', domain: 'dxc.com' },
  { name: 'TCS', domain: 'tcs.com' },
  { name: 'Infosys', domain: 'infosys.com' },
  { name: 'Capgemini', domain: 'capgemini.com' },
  { name: 'Vodafone', domain: 'vodafone.com' },
  { name: 'Hyundai', domain: 'hyundai.com' },
  { name: 'Mahindra', domain: 'mahindra.com' },
  { name: 'Sutherland', domain: 'sutherlandglobal.com' },
  { name: 'LTIMindtree', domain: 'ltimindtree.com' },
  { name: 'DHL', domain: 'dhl.com' },
  { name: 'Synechron', domain: 'synechron.com' },
];

export const TRAINING_PROGRAMS = [
  {
    id: 'genai',
    icon: 'Sparkles',
    title: 'Generative AI & LLMs',
    desc: 'From tokenization to deployment — master GPT, Claude, and Llama with production-grade prompts.',
    audience: 'Beginner–Intermediate',
    duration: '1-day workshop · 3-day bootcamp',
  },
  {
    id: 'agentic',
    icon: 'Bot',
    title: 'Agentic AI & Claude Agents',
    desc: 'Build autonomous multi-step agents that plan, reason, and act. Covers MCP, tool-use, and orchestration.',
    audience: 'Advanced',
    duration: '2-day intensive',
  },
  {
    id: 'claude-code',
    icon: 'Terminal',
    title: 'Claude Code for Developers',
    desc: 'Ship features 40% faster with AI-pair programming. Real workflows, not toy demos.',
    audience: 'Developer Track',
    duration: '1-day hands-on',
  },
  {
    id: 'rag',
    icon: 'Database',
    title: 'RAG & Vector DB Systems',
    desc: 'Pinecone, Weaviate, pgvector. Chunking strategies, hybrid search, re-ranking — production patterns.',
    audience: 'Technical',
    duration: '2-day workshop',
  },
  {
    id: 'mlops',
    icon: 'Workflow',
    title: 'MLOps & Production ML',
    desc: 'CI/CD for models, monitoring, drift detection, feature stores. From notebook to scale.',
    audience: 'Engineering',
    duration: '3-day bootcamp',
  },
  {
    id: 'nlp',
    icon: 'MessagesSquare',
    title: 'NLP & Conversational AI',
    desc: 'BERT, Transformers, fine-tuning, and voice bots with STT+TTS pipelines.',
    audience: 'Applied',
    duration: '2-day workshop',
  },
  {
    id: 'ds',
    icon: 'BarChart3',
    title: 'Data Science with Python',
    desc: 'Pandas, scikit-learn, XGBoost, and the statistical foundations that actually matter.',
    audience: 'Foundational',
    duration: '5-day bootcamp',
  },
  {
    id: 'aws',
    icon: 'Cloud',
    title: 'AWS + SageMaker for ML',
    desc: 'Glue, SageMaker, Bedrock. End-to-end ML on AWS with real deployment pipelines.',
    audience: 'Cloud',
    duration: '2-day workshop',
  },
  {
    id: 'cxo',
    icon: 'Brain',
    title: 'AI Strategy for CXOs',
    desc: 'Cut through the hype. Evaluate vendors, set budgets, de-risk AI investments.',
    audience: 'Executive',
    duration: 'Half-day executive briefing',
  },
];

export const IMPACT = [
  { value: 40, suffix: '%', label: 'Reduction in dev time', sub: 'Claude Code automation' },
  { value: 60, suffix: '%', label: 'Manual testing overhead cut', sub: 'AI QA agents' },
  { value: 30, suffix: '+', label: 'Successful hires', sub: 'AI hiring platform (Fortune 500)' },
  { value: 70, suffix: '%', label: 'Call volume automated', sub: 'In-house STT + BERT system' },
];

export const TESTIMONIALS = [
  {
    quote: "Parth's Agentic AI workshop was the most practical session our data team has attended in years. We walked out with working prototypes, not just slides.",
    name: 'Priya Menon',
    title: 'Head of Data Science',
    company: 'Fortune 500 Bank',
  },
  {
    quote: "The Claude Code training transformed how our engineers think about AI-assisted development. Sprint velocity improved within weeks.",
    name: 'Arjun Iyer',
    title: 'Engineering Lead',
    company: 'Global IT Services',
  },
  {
    quote: "Finally an AI trainer who's actually built production systems. No fluff, pure depth. Our CXO cohort asked for a follow-up immediately.",
    name: 'Neha Kapoor',
    title: 'L&D Director',
    company: 'Telecom Major',
  },
  {
    quote: "Parth covered RAG, vector DBs, and agentic pipelines in one day — and made it accessible to both engineers and managers in the room.",
    name: 'Rohan Das',
    title: 'VP Technology',
    company: 'Automotive OEM',
  },
  {
    quote: "Best ROI on a training investment in 2024. Our team went from zero to building an LLM pipeline in 3 days.",
    name: 'Kavya Reddy',
    title: 'Chief Data Officer',
    company: 'Logistics Giant',
  },
  {
    quote: "Real production experience, zero fluff. Parth's credibility is felt from the first five minutes. The whole room stayed engaged throughout.",
    name: 'Sandeep Kumar',
    title: 'CHRO',
    company: 'Consulting Firm',
  },
];

export const STEPS = [
  { n: '01', title: 'Discovery Call', desc: 'We align on your team\'s AI maturity, goals, and gaps. 30 minutes, no slides.' },
  { n: '02', title: 'Custom Curriculum Design', desc: 'I tailor every module to your stack, domain, and role mix — no generic decks.' },
  { n: '03', title: 'Pre-Training Assessment', desc: 'Participants complete a skills snapshot so Day 1 hits the ground running.' },
  { n: '04', title: 'Live Training', desc: 'Hands-on, production-focused sessions onsite or virtual with real tools and repos.' },
  { n: '05', title: 'Post-Training Support', desc: 'Slides, GitHub repos, prompt libraries, plus a 2-week async Q&A window.' },
];

export const TOPICS = [
  'Generative AI', 'LLMs', 'RAG', 'Vector Databases', 'Agentic AI', 'Claude Agents',
  'Claude Code', 'Prompt Engineering', 'Python for ML', 'Data Science', 'NLP',
  'BERT', 'Transformers', 'Fine-tuning', 'MLOps', 'LangChain', 'LangGraph', 'CrewAI',
  'AutoGen', 'HuggingFace', 'AWS SageMaker', 'AWS Glue', 'Snowflake', 'Docker',
  'Machine Learning', 'Deep Learning', 'XGBoost', 'Random Forests', 'SQL for Data',
  'AI Strategy', 'AI for CXOs', 'Text2SQL', 'Document Intelligence',
];

export const BLOG_POSTS = [
  {
    tag: 'AGENTIC AI',
    title: 'Why Agentic AI Is Different From Regular LLM Prompting',
    readTime: '7 min read',
    img: 'https://images.unsplash.com/photo-1638356554489-decb2e3a4c37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlJTIwbmV1cmFsJTIwbmV0d29yayUyMGRhcmt8ZW58MHx8fHwxNzc3MDQyMDIxfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    tag: 'CLAUDE CODE',
    title: 'How I Cut Manual Testing by 60% Using Claude Agents',
    readTime: '5 min read',
    img: 'https://images.pexels.com/photos/17483874/pexels-photo-17483874.png',
  },
  {
    tag: 'RAG',
    title: 'RAG vs Fine-tuning: When to Use Which (With Real Examples)',
    readTime: '9 min read',
    img: 'https://images.pexels.com/photos/14314636/pexels-photo-14314636.jpeg',
  },
];
